import _defineProperty from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _asyncToGenerator from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/asyncToGenerator.js";
var __jsx = React.createElement;
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useState, useRef, useEffect } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faPaperPlaneTop, faMicrophone, faUserTag, faTimes, faStop, faSearch, faMemoPad, faStar, faFileLines, faArrowsRotate, faLayerGroup } from "@fortawesome/pro-regular-svg-icons";
import classNames from "classnames";
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import { isEmpty } from "lodash";
import promptsData from "../PromptsModal/prompts.json";
import { trackEvent } from "../../../utils/mixpanel";
import { MIXPANEL_EVENTS } from "../../../utils/mixpanelEvents";
import useCallOrchestrator from "../utils/services/useCallOrchestrator";
import { useCopilotChat, useCopilotMessagesContext } from "@copilotkit/react-core";
import { Role, TextMessage } from "@copilotkit/runtime-client-gql";
var placeholders = ["Type `/` to see all available actions and prompts.", "Click the mic and Speak: control the assistant handsfree.", "Try `/add patient` to quickly add a new patient.", "Type `/list forms` to see and fill available forms."];
var flattenPrompts = function flattenPrompts(data) {
  return data.sections.flatMap(function (section) {
    return section.prompts.map(function (prompt) {
      return {
        name: prompt.name,
        content: prompt.content,
        section: section.title,
        icon: section.icon
      };
    });
  });
};
var allPrompts = flattenPrompts(promptsData);

// Icon mapping for prompt section headers
var sectionIconMap = {
  faUserTag: faUserTag,
  faSearch: faSearch,
  faMemoPad: faMemoPad,
  faStar: faStar,
  faFileLines: faFileLines,
  faArrowsRotate: faArrowsRotate,
  faLayerGroup: faLayerGroup
};
var ChatInput = function ChatInput(_ref) {
  var onSend = _ref.onSend,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    _ref$inProgress = _ref.inProgress,
    inProgress = _ref$inProgress === void 0 ? false : _ref$inProgress,
    conversationsData = _ref.conversationsData;
  var _useState = useState(""),
    inputValue = _useState[0],
    setInputValue = _useState[1];
  var textareaRef = useRef(null);
  var _useState2 = useState(false),
    isFocused = _useState2[0],
    setIsFocused = _useState2[1];
  var _useState3 = useState(0),
    currentPlaceholder = _useState3[0],
    setCurrentPlaceholder = _useState3[1];
  var _useState4 = useState(true),
    isPlaceholderVisible = _useState4[0],
    setIsPlaceholderVisible = _useState4[1];
  var _useState5 = useState(false),
    isTranscribing = _useState5[0],
    setIsTranscribing = _useState5[1];
  var recognitionRef = useRef(null);
  var transcribeTimeoutRef = useRef(null);
  var _useState6 = useState(""),
    interimTranscript = _useState6[0],
    setInterimTranscript = _useState6[1];
  var _useState7 = useState(false),
    showPromptDropdown = _useState7[0],
    setShowPromptDropdown = _useState7[1];
  var _useState8 = useState(allPrompts),
    filteredPrompts = _useState8[0],
    setFilteredPrompts = _useState8[1];
  var _useState9 = useState(0),
    selectedPromptIndex = _useState9[0],
    setSelectedPromptIndex = _useState9[1];
  var textareaContainerRef = useRef(null);
  var promptItemRefs = useRef([]);
  var _useState0 = useState(null),
    selection = _useState0[0],
    setSelection = _useState0[1];
  var baseInputValueRef = useRef("");
  var baseSelectionRef = useRef(null);
  var promptDropdownOpenedRef = useRef(false);
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        patientDetail: s.patientDetail,
        chatInputContent: s.chatInputContent,
        isDraggableModalOpen: s.isDraggableModalOpen
      };
    }),
    patientDetail = _useStoreState.patientDetail,
    chatInputContent = _useStoreState.chatInputContent,
    isDraggableModalOpen = _useStoreState.isDraggableModalOpen;
  var isPatientUsingOrchestrator = Store.getRawState().currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id];
  var isDisabled = isPatientUsingOrchestrator && isPatientUsingOrchestrator.status !== "completed" && isPatientUsingOrchestrator.status !== "request_failed" && (isPatientUsingOrchestrator === null || isPatientUsingOrchestrator === void 0 ? void 0 : isPatientUsingOrchestrator.status) !== "timeout" && (isPatientUsingOrchestrator === null || isPatientUsingOrchestrator === void 0 ? void 0 : isPatientUsingOrchestrator.conversation_id) === Store.getRawState().assistantThreadId || disabled;
  useEffect(function () {
    var interval;
    var timeout;
    var startRotation = function startRotation() {
      interval = setInterval(function () {
        setIsPlaceholderVisible(false);
        timeout = setTimeout(function () {
          setCurrentPlaceholder(function (prev) {
            return (prev + 1) % placeholders.length;
          });
          setIsPlaceholderVisible(true);
        }, 500);
      }, 6000);
    };
    var stopRotation = function stopRotation() {
      if (interval) {
        clearInterval(interval);
      }
      if (timeout) {
        clearTimeout(timeout);
      }
      setIsPlaceholderVisible(true);
    };
    if (!inputValue.trim()) {
      startRotation();
    } else {
      stopRotation();
    }
    return function () {
      stopRotation();
    };
  }, [inputValue]); // Add inputValue as dependency to react to changes

  // Add clipboard monitoring
  useEffect(function () {
    if (isDraggableModalOpen && chatInputContent) {
      setInputValue(chatInputContent);
      setTimeout(function () {
        Store.update(function (s) {
          s.chatInputContent = "";
        });
      }, 900);
    }
  }, [isDraggableModalOpen]);
  useEffect(function () {
    if (!inProgress) {
      var _textareaRef$current;
      (_textareaRef$current = textareaRef.current) === null || _textareaRef$current === void 0 || _textareaRef$current.focus();
    }
  }, [inProgress]);

  // Auto-resize textarea
  useEffect(function () {
    if (textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = "".concat(Math.min(textareaRef.current.scrollHeight, 200), "px");
    }
  }, [inputValue, isDraggableModalOpen]);

  // Reset textarea height when modal is minimized
  useEffect(function () {
    if (!isDraggableModalOpen && textareaRef.current) {
      textareaRef.current.style.height = "auto";
      textareaRef.current.style.height = "60px"; // Set a default height when minimized
    }
  }, [isDraggableModalOpen]);

  // Clean up recognition and timer on unmount
  useEffect(function () {
    return function () {
      if (recognitionRef.current) {
        recognitionRef.current.onresult = null;
        recognitionRef.current.onerror = null;
        recognitionRef.current.onend = null;
        recognitionRef.current.stop();
      }
      if (transcribeTimeoutRef.current) {
        clearTimeout(transcribeTimeoutRef.current);
      }
    };
  }, []);
  useEffect(function () {
    var handleShortcut = function handleShortcut(e) {
      // CMD+K (Mac) or CTRL+K (Windows/Linux)
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        // Only trigger if input is visible (optionally: isDraggableModalOpen)
        if (!isDisabled && !inProgress) {
          handleMicClick();
        }
      }
    };
    window.addEventListener("keydown", handleShortcut);
    return function () {
      return window.removeEventListener("keydown", handleShortcut);
    };
  }, [isDisabled, inProgress, isTranscribing]);
  useEffect(function () {
    var match = inputValue.match(/(^|\s)\/(\w*)$/);
    if (match) {
      setShowPromptDropdown(true);
      var filtered = allPrompts.filter(function (p) {
        return p.name.toLowerCase().includes((match[2] || "").toLowerCase());
      });
      setFilteredPrompts(filtered);
      setSelectedPromptIndex(0);
    } else {
      setShowPromptDropdown(false);
      setFilteredPrompts(allPrompts);
      setSelectedPromptIndex(0);
    }
  }, [inputValue]);

  // Scroll selected prompt into view when selectedPromptIndex changes
  useEffect(function () {
    if (showPromptDropdown && filteredPrompts.length > 0) {
      var ref = promptItemRefs.current[selectedPromptIndex];
      if (ref) {
        ref.scrollIntoView({
          block: "nearest"
        });
      }
    }
  }, [selectedPromptIndex, showPromptDropdown, filteredPrompts]);

  // Track prompt modal open (slash) only on first open per session
  useEffect(function () {
    if (showPromptDropdown && !promptDropdownOpenedRef.current) {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_PROMPT_MODAL_OPEN, {
        method: "slash"
      });
      promptDropdownOpenedRef.current = true;
    }
    if (!showPromptDropdown) {
      promptDropdownOpenedRef.current = false;
    }
  }, [showPromptDropdown]);
  var _useStoreState2 = useStoreState(Store, function (s) {
      return {
        userInfo: s.userInfo,
        assistantThreadId: s.assistantThreadId
      };
    }),
    userInfo = _useStoreState2.userInfo,
    assistantThreadId = _useStoreState2.assistantThreadId;
  var _useCopilotMessagesCo = useCopilotMessagesContext(),
    messages = _useCopilotMessagesCo.messages;
  var messagesRef = useRef(messages);
  useEffect(function () {
    messagesRef.current = messages;
  }, [messages]);
  var patientDetailRef = useRef(patientDetail);
  useEffect(function () {
    patientDetailRef.current = patientDetail;
  }, [patientDetail]);
  var assistantThreadIdRef = useRef(assistantThreadId);
  useEffect(function () {
    assistantThreadIdRef.current = assistantThreadId;
  }, [assistantThreadId]);
  var callOrchestrator = useCallOrchestrator(userInfo === null || userInfo === void 0 ? void 0 : userInfo.default_workspace, assistantThreadIdRef.current);
  var _useCopilotChat = useCopilotChat(),
    appendMessage = _useCopilotChat.appendMessage;
  var handleOrchestrator = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      var isMessageSaved, attempts, maxAttempts, intervalMs, lastUserMessage, lastUserMessageId, params, response;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            Store.update(function (s) {
              s.isUsingOrchestrator = true;
            });
            isMessageSaved = false;
            attempts = 0;
            maxAttempts = 100;
            intervalMs = 1000; // ✅ Poll every 1 second, max 10 tries
          case 1:
            if (!(attempts < maxAttempts && !isMessageSaved)) {
              _context.n = 4;
              break;
            }
            lastUserMessage = messagesRef.current.sort(function (a, b) {
              return a.createdAt - b.createdAt;
            }).findLast(function (message) {
              return message.role === "user";
            });
            lastUserMessageId = lastUserMessage === null || lastUserMessage === void 0 ? void 0 : lastUserMessage.id;
            if (!(lastUserMessageId === Store.getRawState().lastSavedUserMessageId)) {
              _context.n = 2;
              break;
            }
            isMessageSaved = true;
            return _context.a(3, 4);
          case 2:
            _context.n = 3;
            return new Promise(function (resolve) {
              return setTimeout(resolve, intervalMs);
            });
          case 3:
            attempts++;
            _context.n = 1;
            break;
          case 4:
            if (!isMessageSaved) {
              console.warn("⚠️ Message not saved within timeout. Proceeding anyway...");
            }

            // ✅ Continue to orchestrator call
            if (!isMessageSaved) {
              _context.n = 6;
              break;
            }
            params = {
              patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id
            };
            Store.update(function (s) {
              s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                status: "request_started",
                conversation_id: Store.getRawState().assistantThreadId
              };
              s.wsEvents[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = [];
            });
            _context.n = 5;
            return callOrchestrator.mutateAsync(params, {
              onSuccess: function onSuccess(data) {
                Store.update(function (s) {
                  s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                    patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                    status: "request_success",
                    conversation_id: Store.getRawState().assistantThreadId
                  };
                });
                var patientId = patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id;
                var attempts = 0;
                var maxAttempts = 6 * 60; // 6 minutes

                var pollInterval = setInterval(function () {
                  var _Store$getRawState$cu;
                  attempts++;
                  var currentStatus = (_Store$getRawState$cu = Store.getRawState().currentPatientsUsingOrchestrator[patientId]) === null || _Store$getRawState$cu === void 0 ? void 0 : _Store$getRawState$cu.status;

                  // Check if status has changed from "request_success"
                  if (currentStatus && currentStatus !== "request_success") {
                    clearInterval(pollInterval);
                    return;
                  }

                  // Check if we've reached max attempts (100 seconds)
                  if (attempts >= maxAttempts) {
                    Store.update(function (s) {
                      s.currentPatientsUsingOrchestrator[patientId] = _objectSpread(_objectSpread({}, s.currentPatientsUsingOrchestrator[patientId]), {}, {
                        status: "timeout"
                      });
                    });
                    appendMessage(new TextMessage({
                      role: Role.Assistant,
                      content: "Timeout: LLM orchestrator is taking too long to respond. Please try again.",
                      id: "".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
                    }), {
                      followUp: false
                    });
                    clearInterval(pollInterval);
                    return;
                  }
                }, 1000); // Check every 1 second
              },
              onError: function onError(error) {
                Store.update(function (s) {
                  s.currentPatientsUsingOrchestrator[patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id] = {
                    patient_id: patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_uid,
                    status: "request_failed",
                    conversation_id: Store.getRawState().assistantThreadId
                  };
                });
                console.error("The task is failed. Please try again.", error);
                appendMessage(new TextMessage({
                  role: Role.Assistant,
                  content: "The task is failed. Please try again.",
                  id: "".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
                }), {
                  followUp: false
                });
              }
            });
          case 5:
            response = _context.v;
          case 6:
            return _context.a(2);
        }
      }, _callee);
    }));
    return function handleOrchestrator() {
      return _ref2.apply(this, arguments);
    };
  }();
  var handleSubmit = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(e) {
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.n) {
          case 0:
            e === null || e === void 0 || e.preventDefault();
            // Stop recording if active
            if (isTranscribing) {
              stopRecognition();
            }
            if (!Store.getRawState().hasChosenAssistantMode && Store.getRawState().hasUserSentMessage === false) {
              Store.update(function (s) {
                s.hasChosenAssistantMode = true;
              });
            }
            if (!(inputValue.trim() && !isDisabled && !inProgress)) {
              _context2.n = 1;
              break;
            }
            // Track send via button
            if (e && e.type === "click") {
              trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_SEND_BUTTON);
            }
            if (Store.getRawState().assistantMode === "simple") {
              onSend(inputValue);
              Store.update(function (s) {
                s.hasUserSentMessage = true;
              });
            }
            setInputValue("");
            if (!(Store.getRawState().assistantMode === "workflow")) {
              _context2.n = 1;
              break;
            }
            appendMessage(new TextMessage({
              role: Role.User,
              content: inputValue,
              id: "ck-".concat(Date.now(), "_").concat(Math.random().toString(36).substr(2, 9))
            }), {
              followUp: false
            });
            Store.update(function (s) {
              s.hasUserSentMessage = true;
              s.customSuggestions = [];
              s.lastAssitantMessageId = "";
            });
            _context2.n = 1;
            return handleOrchestrator();
          case 1:
            Store.update(function (s) {
              s.lastAssitantMessageId = "";
            });
          case 2:
            return _context2.a(2);
        }
      }, _callee2);
    }));
    return function handleSubmit(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var handleKeyDown = function handleKeyDown(e) {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      // Track send via enter
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_SEND_ENTER);
      handleSubmit();
    }
  };
  var stopRecognition = function stopRecognition() {
    var _recognitionRef$curre;
    (_recognitionRef$curre = recognitionRef.current) === null || _recognitionRef$curre === void 0 || _recognitionRef$curre.stop();
    setIsTranscribing(false);
    setIsPlaceholderVisible(true);
    if (transcribeTimeoutRef.current) {
      clearTimeout(transcribeTimeoutRef.current);
    }
    // Track stop recording
    trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_STOP_RECORDING);
  };
  var handleSelect = function handleSelect(e) {
    var sel = {
      start: e.currentTarget.selectionStart,
      end: e.currentTarget.selectionEnd
    };
    setSelection(sel);
    baseSelectionRef.current = sel;
  };

  // Insert or replace text at selection
  var insertAtSelection = function insertAtSelection(text, baseValue, selection) {
    if (!selection) return baseValue + text;
    var start = selection.start,
      end = selection.end;
    return baseValue.slice(0, start) + text + baseValue.slice(end);
  };

  // Handle speech recognition results
  var handleSpeechResult = function handleSpeechResult(_final, interim) {
    if (_final) {
      var baseValue = baseInputValueRef.current;
      var sel = baseSelectionRef.current || {
        start: baseValue.length,
        end: baseValue.length
      };
      var newValue = insertAtSelection(_final, baseValue, sel);
      setInputValue(newValue);
      baseInputValueRef.current = newValue;
      setTimeout(function () {
        if (textareaRef.current) {
          var newPos = sel.start + _final.length;
          textareaRef.current.focus();
          textareaRef.current.setSelectionRange(newPos, newPos);
          setSelection({
            start: newPos,
            end: newPos
          });
          baseSelectionRef.current = {
            start: newPos,
            end: newPos
          };
        }
      }, 0);
      setInterimTranscript("");
    } else {
      setInterimTranscript(interim);
    }
  };
  var handleMicClick = function handleMicClick() {
    if (isTranscribing) {
      stopRecognition();
      return;
    }
    // Track speak button
    trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_SPEAK);
    // Set baseInputValue and baseSelection to current state when starting transcription
    if (textareaRef.current) {
      baseInputValueRef.current = inputValue;
      baseSelectionRef.current = {
        start: textareaRef.current.selectionStart,
        end: textareaRef.current.selectionEnd
      };
    } else {
      baseInputValueRef.current = inputValue;
      baseSelectionRef.current = selection || {
        start: inputValue.length,
        end: inputValue.length
      };
    }
    var SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    if (!SpeechRecognition) {
      alert("Speech recognition is not supported in this browser.");
      return;
    }
    var recognition = new SpeechRecognition();
    recognition.lang = "en-US";
    recognition.interimResults = true;
    recognition.continuous = true;
    recognition.onresult = function (event) {
      var interim = "";
      var _final2 = "";
      for (var i = event.resultIndex; i < event.results.length; ++i) {
        var transcript = event.results[i][0].transcript;
        if (event.results[i].isFinal) {
          _final2 += transcript;
        } else {
          interim += transcript;
        }
      }
      handleSpeechResult(_final2, interim);
    };
    recognition.onerror = function (event) {
      setIsTranscribing(false);
      if (transcribeTimeoutRef.current) {
        clearTimeout(transcribeTimeoutRef.current);
      }
    };
    recognition.onend = function () {
      setIsTranscribing(false);
      if (transcribeTimeoutRef.current) {
        clearTimeout(transcribeTimeoutRef.current);
      }
    };
    recognitionRef.current = recognition;
    setIsTranscribing(true);
    setInterimTranscript("");
    recognition.start();
  };

  // Keyboard navigation for prompt dropdown
  var handlePromptKeyDown = function handlePromptKeyDown(e) {
    if (!showPromptDropdown || filteredPrompts.length === 0) return;
    e.stopPropagation();
    if (e.key === "ArrowDown") {
      e.preventDefault();
      setSelectedPromptIndex(function (i) {
        return (i + 1) % filteredPrompts.length;
      });
    } else if (e.key === "ArrowUp") {
      e.preventDefault();
      setSelectedPromptIndex(function (i) {
        return (i - 1 + filteredPrompts.length) % filteredPrompts.length;
      });
    } else if (e.key === "Tab" || e.key === "Enter") {
      e.preventDefault();
      if (filteredPrompts[selectedPromptIndex]) {
        selectPrompt(filteredPrompts[selectedPromptIndex]);
      }
    } else if (e.key === "Escape") {
      setShowPromptDropdown(false);
    }
  };

  // Insert prompt content into input and place cursor at end
  var selectPrompt = function selectPrompt(prompt) {
    var placeholder = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "/";
    // Track prompt selected
    trackEvent(MIXPANEL_EVENTS.ASSISTANT_PROMPT_SELECTED, {
      promptName: prompt.name
    });
    setInputValue(function (prev) {
      var newValue = placeholder === "/" ? prev.replace(/(^|\s)\/(\w*)$/, "$1".concat(prompt.content)) : prev.replace(/(^|\s)\@(\w*)$/, "$1@".concat(prompt.content, " "));
      setTimeout(function () {
        if (textareaRef.current) {
          textareaRef.current.focus();
          textareaRef.current.setSelectionRange(newValue.length, newValue.length);
        }
      }, 0);
      return newValue;
    });
    setShowPromptDropdown(false);
    setFilteredPrompts(allPrompts);
    setSelectedPromptIndex(0);
  };

  // Attach keydown handler to textarea
  useEffect(function () {
    var textarea = textareaRef.current;
    if (!textarea) return;
    var handler = function handler(e) {
      return handlePromptKeyDown(e);
    };
    textarea.addEventListener("keydown", handler);
    return function () {
      return textarea.removeEventListener("keydown", handler);
    };
  }, [showPromptDropdown, filteredPrompts, selectedPromptIndex]);
  return /*#__PURE__*/React.createElement("form", {
    onSubmit: handleSubmit,
    className: "relative w-full"
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col w-full "
  }, /*#__PURE__*/React.createElement("div", {
    ref: textareaContainerRef,
    className: classNames("relative w-full transition-all duration-200 overflow-hidden [background:linear-gradient(0deg,rgba(152,174,217,0.72)_0%,transparent_100%)]")
  }, /*#__PURE__*/React.createElement("div", {
    className: classNames("relative m-4 dark:bg-gray-900 bg-gray-200 rounded-xl border-y border-brand-peach", isEmpty(patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id) && "rounded-t-2xl")
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: "relative flex items-end"
  }, /*#__PURE__*/React.createElement("textarea", {
    ref: textareaRef,
    value: function () {
      if (isTranscribing && interimTranscript) {
        var baseValue = baseInputValueRef.current;
        var sel = baseSelectionRef.current || {
          start: baseValue.length,
          end: baseValue.length
        };
        return insertAtSelection(interimTranscript, baseValue, sel);
      }
      return inputValue;
    }(),
    onChange: function onChange(e) {
      setInputValue(e.target.value);
      baseInputValueRef.current = e.target.value;
      var sel = {
        start: e.target.selectionStart,
        end: e.target.selectionEnd
      };
      setSelection(sel);
      baseSelectionRef.current = sel;
    },
    onKeyDown: handleKeyDown,
    onFocus: function onFocus() {
      return setIsFocused(true);
    },
    onBlur: function onBlur() {
      return setIsFocused(false);
    },
    onSelect: handleSelect,
    placeholder: isTranscribing ? "" : Store.getRawState().assistantMode === "simple" ? placeholders[currentPlaceholder] : "Ask AIRA...",
    disabled: inProgress || isDisabled,
    className: classNames("w-full px-3 py-3 pr-24 bg-transparent text-gray-800 dark:text-gray-100 placeholder-gray-500 dark:placeholder-gray-600 resize-none disabled:opacity-50 disabled:cursor-not-allowed border-0 focus:border-0 focus:outline-none", "transition-opacity duration-500 min-h-[60px]", "scrollbar-light dark:scrollbar"),
    style: {
      maxHeight: isDraggableModalOpen ? "200px" : "40px",
      overflowY: "auto",
      opacity: Store.getRawState().assistantMode === "simple" ? isPlaceholderVisible ? 1 : 0 : 1
    },
    rows: 1
  }), /*#__PURE__*/React.createElement("div", {
    className: classNames("absolute right-4 bottom-4 flex items-center space-x-3 transition-all duration-300")
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    onClick: isTranscribing ? stopRecognition : handleMicClick,
    className: classNames("p-2 rounded-full transition-colors duration-200", isTranscribing ? "bg-[#FF7869]/20 text-[#FF7869]" : "text-gray-700 dark:text-gray-300 hover:bg-gray-400 dark:hover:bg-gray-500"),
    "aria-label": isTranscribing ? "Stop recording" : "Start recording",
    disabled: inProgress || isDisabled
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: isTranscribing ? faStop : faMicrophone,
    size: "lg"
  })), /*#__PURE__*/React.createElement("button", {
    onClick: handleSubmit,
    disabled: inProgress || isDisabled,
    className: "flex items-center justify-center w-7 h-7 cursor-pointer bg-[#98AED9] dark:bg-[#98AED9] hover:opacity-80 text-gray-900 rounded-full transition-all duration-200 transform hover:scale-105"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faPaperPlaneTop,
    size: "1x"
  })))), /*#__PURE__*/React.createElement("div", {
    className: "flex items-center justify-between mt-3 px-1"
  }, isTranscribing && /*#__PURE__*/React.createElement("button", {
    type: "button",
    "aria-label": "Clear text",
    className: "flex items-center px-4 py-2 cursor-pointer group rounded-full text-gray-500 dark:text-gray-400 hover:text-[#FF7869] hover:bg-[#FF7869]/10 transition-all duration-200",
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_CLEAR);
      setInputValue("");
      setInterimTranscript("");
      baseInputValueRef.current = "";
      baseSelectionRef.current = {
        start: 0,
        end: 0
      };
      setSelection({
        start: 0,
        end: 0
      });
    }
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faTimes,
    size: "lg"
  }), /*#__PURE__*/React.createElement("span", {
    className: "ml-2 text-base font-medium group-hover:opacity-100 translate-x-0 group-hover:translate-x-1 opacity-0 transition-all duration-200"
  }, "Clear")), /*#__PURE__*/React.createElement("div", {
    className: "flex-1"
  }))))), showPromptDropdown && Store.getRawState().assistantMode === "simple" && filteredPrompts.length > 0 && /*#__PURE__*/React.createElement("div", {
    className: "absolute left-0 bottom-[70%] mb-0 z-50 min-w-[250px] max-w-[350px] w-10/12 scrollbar-light dark:scrollbar z-100",
    style: {
      pointerEvents: "auto"
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "bg-white dark:bg-gray-900 border border-gray-300 dark:border-gray-700 rounded-lg shadow-2xl max-h-64 overflow-y-auto"
  }, function () {
    var sectionMap = {};
    filteredPrompts.forEach(function (prompt) {
      if (!sectionMap[prompt.section]) {
        sectionMap[prompt.section] = {
          icon: prompt.icon,
          prompts: []
        };
      }
      sectionMap[prompt.section].prompts.push(prompt);
    });
    var orderedSections = promptsData.sections.map(function (section) {
      return section.title;
    }).filter(function (title) {
      return sectionMap[title];
    });
    return orderedSections.map(function (sectionTitle, sectionIdx) {
      return /*#__PURE__*/React.createElement(React.Fragment, {
        key: sectionTitle
      }, /*#__PURE__*/React.createElement("div", {
        className: "sticky top-0 z-10 flex items-center gap-2 px-4 pt-3 pb-1 bg-gray-50 dark:bg-gray-800 border-b border-gray-200 dark:border-gray-700 font-semibold text-gray-700 dark:text-gray-200 text-sm"
      }, sectionMap[sectionTitle].icon && /*#__PURE__*/React.createElement(AwesomeIcon, {
        name: sectionIconMap[sectionMap[sectionTitle].icon],
        className: "w-4 h-4 text-brand-peach"
      }), /*#__PURE__*/React.createElement("span", null, sectionTitle)), sectionMap[sectionTitle].prompts.map(function (prompt, idx) {
        var globalIdx = filteredPrompts.findIndex(function (p) {
          return p.name === prompt.name && p.section === prompt.section;
        });
        return /*#__PURE__*/React.createElement("div", {
          key: prompt.name + idx,
          ref: function ref(el) {
            return promptItemRefs.current[globalIdx] = el;
          },
          className: "flex items-center px-4 py-2 cursor-pointer transition-colors duration-150 border-l-4 border-transparent\n                              ".concat(globalIdx === selectedPromptIndex ? "bg-teal-100 dark:bg-teal-900 border-teal-400/80" : "hover:bg-teal-50 dark:hover:bg-teal-900", "\n                              "),
          onMouseDown: function onMouseDown(e) {
            e.preventDefault();
            selectPrompt(prompt);
          },
          onMouseEnter: function onMouseEnter() {
            return setSelectedPromptIndex(globalIdx);
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "font-semibold text-gray-800 dark:text-gray-100"
        }, prompt.name));
      }));
    });
  }(), filteredPrompts.length === 0 && /*#__PURE__*/React.createElement("div", {
    className: "px-4 py-2 text-gray-400"
  }, "No prompts found"))), /*#__PURE__*/React.createElement("div", {
    className: "items-center justify-between mt-3 px-1 hidden"
  }, (patientDetail === null || patientDetail === void 0 ? void 0 : patientDetail.patient_id) && /*#__PURE__*/React.createElement("div", {
    className: "flex items-center  backdrop-blur-sm rounded-full p-1 border border-white/30"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_CLEAR);
      setInputValue("");
      baseInputValueRef.current = "";
      baseSelectionRef.current = {
        start: 0,
        end: 0
      };
      setSelection({
        start: 0,
        end: 0
      });
      Store.update(function (s) {
        var _conversationsData$re;
        s.assistantMode = "simple";
        s.areFrontendToolsEnabled = true;
        s.assistantThreadId = conversationsData === null || conversationsData === void 0 || (_conversationsData$re = conversationsData.results) === null || _conversationsData$re === void 0 || (_conversationsData$re = _conversationsData$re[0]) === null || _conversationsData$re === void 0 ? void 0 : _conversationsData$re.conversation_id;
        s.customSuggestions = [];
      });
    },
    className: classNames("px-3 py-1 text-xs  rounded-full transition-colors font-bold", Store.getRawState().assistantMode === "simple" ? "bg-white/30 text-teal-700 dark:text-teal-200 shadow-sm" : "text-gray-600 dark:text-gray-200 hover:text-gray-800 dark:hover:text-white hover:bg-white/10")
  }, "General"), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      trackEvent(MIXPANEL_EVENTS.ASSISTANT_CHATINPUT_CLEAR);
      setInputValue("");
      baseInputValueRef.current = "";
      baseSelectionRef.current = {
        start: 0,
        end: 0
      };
      setSelection({
        start: 0,
        end: 0
      });
      Store.update(function (s) {
        var _Store$getRawState$pa;
        s.assistantMode = "workflow";
        s.areFrontendToolsEnabled = false;
        s.assistantThreadId = (_Store$getRawState$pa = Store.getRawState().patientConversations) === null || _Store$getRawState$pa === void 0 || (_Store$getRawState$pa = _Store$getRawState$pa[0]) === null || _Store$getRawState$pa === void 0 ? void 0 : _Store$getRawState$pa.conversation_id;
      });
    },
    className: classNames("px-3 py-1 text-xs font-medium rounded-full transition-colors", Store.getRawState().assistantMode === "workflow" ? "bg-white/30 text-teal-700 dark:text-teal-200 shadow-sm" : "text-gray-600 dark:text-gray-200 hover:text-gray-800 dark:hover:text-white hover:bg-white/10")
  }, "Patient")), /*#__PURE__*/React.createElement("div", {
    className: "sm:text-sm text-gray-600 dark:text-gray-100 opacity-80 text-center flex-1 pl-2"
  }, "AI-powered assistance \u2022 Secure and private"))));
};
export default ChatInput;